<label for="feature_{{feature.id}}">
  {{ feature.header }}<span *ngIf="feature.unitHeader">, {{ feature.unitHeader }}</span>
  <span *ngIf="isRequired()"> *</span>
  <span *ngIf="feature.comment" nbTooltip="{{feature.comment}}"><nb-icon icon="bulb-outline"></nb-icon></span>
</label>

<div class="accordion-item__right">
  <form [formGroup]="form">
    <div formArrayName="items">
      <div *ngFor="let itemForm of items.controls; let i = index">
        <div [formGroup]="itemForm" class="smartlistItem mb-2">
          <input nbInput
                 class="me-2"
                 fieldSize="small"
                 placeholder="Название параметра"
                 i18n-placeholder="@@SmartlistKeyPlaceholder"
                 formControlName="key"
          />

          <input nbInput
                 class="me-2"
                 fieldSize="small"
                 placeholder="Значение параметра"
                 i18n-placeholder="@@SmartlistValuePlaceholder"
                 formControlName="value"
          />

          <button type="button" (click)="deleteSmartlistItem(i)" nbButton size="small" status="control">
            <nb-icon icon="close"></nb-icon>
          </button>
        </div>
      </div>
    </div>

    <div>
      <button type="button" (click)="addSmartlistItem()" nbButton size="small" status="control" i18n="@@AddSmartlistItem">
        <nb-icon icon="plus-square-outline"></nb-icon>
        Добавить
      </button>
    </div>
  </form>
  <div class="accordion-item__right-info">
    <div class="state-warn" *ngIf="form.valid && isShowEmptyWarning()">
      <nb-icon icon="alert-triangle-outline"/>
    </div>
    <div class="state-err" *ngIf="form.invalid">
      <nb-icon icon="alert-circle-outline"/>
    </div>
    <div class="state-success" *ngIf="form.valid && !isEmpty()">
      <nb-icon icon="checkmark-outline"/>
    </div>

    <a [routerLink]="['/cabinet/pim/feature/edit/', feature.featureId]"
       class="entityID"
       target="_blank"
       i18n-nbTooltip="@@OpenFeatureInNewWindow"
       nbTooltip="Открыть характеристику в новом окне"
       *ngIf="featureLink">
      #{{ feature.featureId }}
    </a>
  </div>
</div>
